import React, { Fragment } from 'react';
import { AppShell, Overlay, useMantineTheme } from '@mantine/core';
import { useBooleanToggle, useMediaQuery } from '@mantine/hooks';

import { NavbarSimple } from './NavbarSimple';
import { HeaderSimple } from './HeaderSimple';

type Props = {
  children: React.ReactNode;
};

const Layout = (props: Props) => {
  const theme = useMantineTheme();
  const collapsed = useMediaQuery(`(max-width: ${theme.breakpoints.md}px)`);
  const [open, toggleOpen] = useBooleanToggle(false);

  return (
    <AppShell
      navbarOffsetBreakpoint="md"
      padding="md"
      fixed
     /*navbar={
        <NavbarSimple
          p="md"
          isOpen={open}
          setOpen={() => toggleOpen()}
          width={{ xs: 300 }}
        />
      }
      header={
        collapsed ? (
          <HeaderSimple
            isOpen={open}
            setOpen={() => toggleOpen()}
            height={60}
          />
        ) : (
          <Fragment />
        )
      }*/  >
      {open && collapsed && (
        <Overlay opacity={0.5} color={theme.colors.dark[9]} sx={{ position: 'fixed', zIndex: 5 }} />
      )}
      {props.children}
    </AppShell>
  );
};

export default Layout;
